import { render } from "./DeviceActivation.vue?vue&type=template&id=af644c9c&scoped=true"
import script from "./DeviceActivation.vue?vue&type=script&lang=js"
export * from "./DeviceActivation.vue?vue&type=script&lang=js"

import "./DeviceActivation.vue?vue&type=style&index=0&id=af644c9c&scoped=true&lang=css"
import "./DeviceActivation.vue?vue&type=style&index=1&id=af644c9c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af644c9c"]])

export default __exports__